<template>
  <section class="page-panel">
    <header class="page-panel__header"><h3 class="panel-title">Rok korištenja</h3></header>
    <div class="page-panel__content grid-stack grid-row-gap-18">
      <div class="grid grid-column-gap-16 grid-row-gap-18">
        <div class="col-12 col-sm-6">
          <RecordReadOnlyField v-if="readonly" label="Od" :value="values.usageFrom ? formatDate(values.usageFrom) : ''" required />
          <AppDateField v-else :model-value="values.usageFrom" label="Od" required @update:model-value="$emit('change', 'usageFrom', $event)" />
        </div>
        <div class="col-12 col-sm-6">
          <RecordReadOnlyField v-if="readonly" label="Do" :value="values.usageTo ? formatDate(values.usageTo) : ''" required />
          <AppDateField v-else :model-value="values.usageTo" label="Do" required @update:model-value="$emit('change', 'usageTo', $event)" />
        </div>
        <div class="col-12 col-sm-6">
          <RecordReadOnlyField v-if="readonly" label="Vozilo treba vratiti najkasnije do" :value="values.returnByTime" required />
          <AppTimeField v-else :model-value="values.returnByTime" label="Vozilo treba vratiti najkasnije do" required @update:model-value="$emit('change', 'returnByTime', $event)" />
        </div>
        <div class="col-12 col-sm-6">
          <RecordReadOnlyField v-if="readonly" label="Mjesto povratka" :value="values.returnLocation" />
          <AppTextField v-else :model-value="values.returnLocation" label="Mjesto povratka" :rules="returnLocationRules" @update:model-value="$emit('change', 'returnLocation', $event)" />
        </div>
        <div class="col-12">
          <RecordReadOnlyField v-if="readonly" label="Poseban dogovor" :value="values.specialArrangement" />
          <AppTextField v-else :model-value="values.specialArrangement" label="Poseban dogovor" :rules="specialArrangementRules" @update:model-value="$emit('change', 'specialArrangement', $event)" />
        </div>
      </div>
      <p v-if="showWorkingHours" class="notice">Radno vrijeme:<br>8,30 - 16,00 (pon. - čet.)<br>8,30 - 13,30 (petak)</p>
    </div>
  </section>
</template>

<script setup>
import { formatDate } from '../../helpers'
import AppDateField from '../AppDateField.vue'
import AppTextField from '../AppTextField.vue'
import AppTimeField from '../AppTimeField.vue'
import RecordReadOnlyField from './RecordReadOnlyField.vue'

defineProps({
  values: { type: Object, required: true },
  readonly: { type: Boolean, default: false },
  showWorkingHours: { type: Boolean, default: true },
})

defineEmits(['change'])

const returnLocationRules = [(value) => String(value ?? '').length <= 255 || 'Najviše 255 znakova']
const specialArrangementRules = [(value) => String(value ?? '').length <= 500 || 'Najviše 500 znakova']
</script>
